import { render, staticRenderFns } from "./TrademarkProvisionalStatusList.vue?vue&type=template&id=32550dd6&"
import script from "./TrademarkProvisionalStatusList.vue?vue&type=script&lang=js&"
export * from "./TrademarkProvisionalStatusList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkProvisionalStatusList.vue?vue&type=style&index=0&id=32550dd6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports